import React from 'react';
import {ModalWrapper} from './modal-wrapper';

export interface CashPendingModalProps {
  imageSrc?: string;
  trackName?: string;
  artist?: string;
  quantity: number;
  transactionHash: string;
  onModalClose: () => void;
}

export const CashPendingModal: React.FC<CashPendingModalProps> = ({
  imageSrc,
  trackName,
  artist,
  quantity,
  transactionHash,
  onModalClose,
}: CashPendingModalProps) => {
  return (
    <ModalWrapper
      title="Processing your payment"
      copyPrimary="This shouldn't take more than a few seconds. Please stay on this page."
      copySecondary="Your payment is being submitted."
      withProcessingIndicator
      imageSrc={imageSrc}
      bottomTransactionHash={transactionHash}
      artist={artist}
      trackName={trackName}
      quantity={quantity}
      onModalClose={onModalClose}
    />
  );
};
